import styled from "styled-components";
import hands from "../../assets/efforts.jpg";
const fontSize = localStorage.getItem("fontSize");

export const Header = styled.header`
  background: url(${hands});
  width: 100%;
  height: 50%;
  display: flex;
  background-repeat: no repeat;
  background-position: center;
  background-size: cover;
  h1 {
    color: white;
    font-size: (${fontSize} + 2rem);
  }
`;

export const Badge = styled.div`
  position: absolute;
  align-self: center;
  background: #62aa51;
  z-index: 9999;
  left: 10%;
  right: 10%;
  width: 80%;
  top: 12rem;
  padding: 2rem;
  text-align: center;
  color: white;
`;

export const EffortsContainer = styled.div`
  width: 80%;
  margin: auto;
  margin-top: 8rem;
  color: #101e8e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const EffortsCard = styled.div`
  display: flex;
  gap: 0;
  align-items: center;
  img {
    width: 50%;
    object-fit: contain;
  }
  p {
    display: flex;
    align-items: center;
    text-align: center;
    height: 100%;
    background: #101e8e;
    color: #fff;
    font-size:(${fontSize} - 0.2rem);
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      font-size: calc(${fontSize} - 0.4rem);
    }
  }
`;

export const EffortsCardContainer = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const InnerEffortsCards = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: 0;
  }
  p {
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: .5rem;
    text-align: center;
    height: 100%;
    background: #101e8e;
    color: #fff;
`;
